<template>
    <div v-if="!loadingPage" class="pb-2">
        <b-card>
            <b-row>
                <b-col md="3" lg="2" class="mt-25">
                    <b-form-group label="تاریخ شروع" label-for="fromId">
                        <b-form-input id="fromId" class="text-center main-input font-weight-bolder pointer"
                            autocomplete="off" name="fromId"
                            :value="parameters.from ? formatDate(parameters.from) : null" />
                        <date-picker v-model="parameters.from" :max="currentDate" format="YYYY-MM-DD"
                            display-format="jYYYY-jMM-jDD" custom-input="#fromId" />
                    </b-form-group>
                </b-col>
                <b-col md="3" lg="2" class="mt-25">
                    <b-form-group label="تاریخ پایان" label-for="toId">
                        <b-form-input id="toId" class="text-center main-input font-weight-bolder pointer" name="toId"
                            autocomplete="off" :value="parameters.to ? formatDate(parameters.to) : null" />
                        <date-picker v-model="parameters.to" :max="currentDate" format="YYYY-MM-DD"
                            display-format="jYYYY-jMM-jDD" custom-input="#toId" />
                    </b-form-group>
                </b-col>
                <b-col md="3" lg="2" class="mt-25">
                    <b-form-group label="شماره همراه مشتری" label-for="customerPhoneNumberId">
                        <b-form-input v-model="parameters.customerPhoneNumber" id="customerPhoneNumberId" dir="ltr"
                            autocomplete="off" class="text-center" name="customerPhoneNumberId" />
                    </b-form-group>
                </b-col>
                <b-col md="3" lg="2" class="mt-25">
                    <b-form-group label="شماره فاکتور" label-for="storeOrderNumberId">
                        <b-form-input v-model="parameters.storeOrderNumber" id="storeOrderNumberId" dir="ltr"
                            autocomplete="off" class="text-center" name="storeOrderNumberId" />
                    </b-form-group>
                </b-col>
                <b-col md="6" lg="4" class="mt-25">
                    <b-form-group label="مجموعه" label-for="storeId">
                        <v-select v-model="parameters.storeId" dir="rtl" :options="listStores" id="storeId"
                            autocomplete="off" :reduce="(value) => value.id"
                            :get-option-label="(option) => option.name_Fa ? option.name_En + ' - ' + option.name_Fa : option.name_En"
                            :clearable="false">
                            <template #option="{ name_En, name_Fa }">
                                {{ name_En }} <span v-if="name_Fa">- {{ name_Fa }}</span>
                            </template>
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col md="3" lg="2" class="mt-25">
                    <b-form-group label="مالیات" label-for="hasTaxId">
                        <v-select v-model="parameters.hasTax" dir="rtl" :options="hasTaxData" id="hasTaxId"
                            autocomplete="off" :reduce="(value) => value.id" style="border-radius: 8px;" label="name"
                            :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col md="3" lg="2" class="mt-25">
                    <b-form-group label="وضعیت مرجوعی" label-for="isReturnedId">
                        <v-select v-model="parameters.isReturned" dir="rtl" :options="isReturnedData" id="isReturnedId"
                            autocomplete="off" :reduce="(value) => value.id" style="border-radius: 8px;" label="name"
                            :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col md="3" lg="2" class="mt-25">
                    <b-form-group label="نوع سفارش" label-for="typeId">
                        <v-select v-model="parameters.type" dir="rtl" :options="typeData" id="typeId" autocomplete="off"
                            :reduce="(value) => value.id" style="border-radius: 8px;" label="name" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col md="3" lg="2" class="mt-25">
                    <b-form-group label="نوع پرداخت" label-for="paymentMethodId">
                        <v-select v-model="parameters.paymentMethod" dir="rtl" :options="paymentMethodData"
                            autocomplete="off" id="paymentMethodId" :reduce="(value) => value.id"
                            style="border-radius: 8px;" label="name" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col md="3" lg="2" class="mt-md-2 mt-1">
                    <b-button @click="removeFilters" variant="info" class="w-100 mt-md-25 mt-0">حذف فیلتر ها</b-button>
                </b-col>
                <b-col md="3" lg="2" class="mt-md-2 mt-1">
                    <b-button @click="allOrders" variant="primary" class="w-100 mt-md-25 mt-0">اعمال
                        فیلتر</b-button>
                </b-col>
            </b-row>
        </b-card>
        <b-card v-if="history.length" class="p-0" no-body>
            <b-overlay :show="loading" variant="transparent" opacity="1" blur="3px" rounded="sm">
                <b-table responsive :items="history" :fields="fields" class="mb-0" striped>
                    <template #cell(isReturned)="data">
                        <div :class="{ 'text-warning': data.item.isReturned }">
                            {{ data.item.isReturned ? 'مرجوع شده' : '-' }}
                        </div>
                    </template>
                    <template #cell(createdAt)="data">
                        <div>
                            <span>
                                {{ new Date(data.item.createdAt).toLocaleDateString('fa-IR') }}
                            </span>
                            <span> - </span>
                            <span>
                                {{ new Date(data.item.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                    2).join(":") }}
                            </span>
                        </div>
                    </template>
                    <template #cell(payableAmount)="data">
                        {{ data.item.payableAmount.toLocaleString('fa-IR') }}
                    </template>
                    <template #cell(usedWalletAmount)="data">
                        {{ data.item.usedWalletAmount.toLocaleString('fa-IR') }}
                    </template>
                    <template #cell(cashbackAmount)="data">
                        {{ data.item.cashbackAmount.toLocaleString('fa-IR') }}
                    </template>
                    <template #cell(paymentMethod)="data">
                        {{ paymentMethod_Status(data.item.paymentMethod) }}
                    </template>
                    <template #cell(type)="data">
                        {{ type_Status(data.item.type) }}
                    </template>
                </b-table>
            </b-overlay>
        </b-card>
        <b-card v-else class="text-center pt-5 pb-4">
            موردی وجود ندارد
        </b-card>
        <b-pagination align="center" @input="allOrders" v-model="parameters.pageIndex"
            :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />

    </div>
</template>

<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BTable, BPagination, BOverlay, BAvatar, BMediaAside, BMedia, BMediaBody, BFormInput, BFormGroup, BSpinner } from 'bootstrap-vue';
import { adminService } from '@core/services';
import vSelect from 'vue-select';

export default {
    components: {
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay,
        BAvatar,
        BMediaAside,
        BMedia,
        BSpinner,
        BMediaBody,
        BFormInput,
        BFormGroup,
        vSelect
    },
    data() {
        return {
            loadingPage: true,
            loading: false,
            loadingButton: false,
            history: [],
            paymentMethodData: [
                { id: null, name: 'نمایش همه' },
                { id: 0, name: 'نقدی' },
                { id: 1, name: 'کارت' },
                { id: 3, name: 'واریز به حساب' },
            ],
            typeData: [
                { id: null, name: 'نمایش همه' },
                { id: 0, name: 'داخل سالن' },
                { id: 1, name: 'بیرون بر' },
            ],
            hasTaxData: [
                { id: null, name: 'نمایش همه' },
                { id: true, name: 'محاسبه شده' },
                { id: false, name: 'محاسبه نشده' },
            ],
            isReturnedData: [
                { id: null, name: 'نمایش همه' },
                { id: true, name: 'مرجوع شده' },
                { id: false, name: 'مرجوع نشده' },
            ],
            fields: [
                {
                    key: 'id',
                    label: 'شناسه فاکتور',
                },
                {
                    key: 'storeName',
                    label: 'شناسه مجموعه',
                },
                {
                    key: 'storeOrderNumber',
                    label: 'شماره فاکتور',
                },
                {
                    key: 'createdAt',
                    label: 'تاریخ',
                },
                {
                    key: 'usedWalletAmount',
                    label: 'اعتبار استفاده شده (ریال)',
                },
                {
                    key: 'payableAmount',
                    label: 'مبلغ پرداخت شده (ریال)',
                },
                {
                    key: 'cashbackAmount',
                    label: 'اعتبار صادر شده (ریال)',
                },
                {
                    key: 'type',
                    label: 'نوع سفارش',
                },
                {
                    key: 'paymentMethod',
                    label: 'نوع پرداخت',
                },
                {
                    key: 'isReturned',
                    label: 'وضعیت مرجوعی',
                },
            ],
            currentDate: '',
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                from: null,
                to: null,
                customerPhoneNumber: null,
                transactionCode: null,
                orderId: null,
                storeOrderNumber: null,
                storeId: null,
                paymentMethod: null,
                isReturned: null,
                hasTax: null,
                type: null,
            },
            orderId: null,
            usersList: [],
            parametersUsers: {
                pageIndex: 1,
                pageSize: 30,
            },
            parametersStores: {
                pageIndex: 1,
                pageSize: 90,
            },
            listStores: []
        }
    },
    computed: {
        type_Status() {
            return (status) => {
                if (status == 0) {
                    return 'داخل سالن'
                }
                if (status == 1) {
                    return 'بیرون بر'
                }
            }
        },
        paymentMethod_Status() {
            return (status) => {
                if (status == 0) {
                    return 'نقدی'
                }
                if (status == 1) {
                    return 'کارت'
                }
                if (status == 2) {
                    return 'درگاه'
                }
                if (status == 3) {
                    return 'واریز به حساب'
                }
                if (status == 255) {
                    return 'ترکیبی'
                }
            }
        },
    },
    methods: {
        formatDate2(date) {
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        },
        formatDate(dateString) {
            const [year, month, day] = dateString.split('-');
            return new Date(year, parseInt(month) - 1, day).toLocaleDateString('fa-IR');
        },
        removeFilters() {
            let currentDate = new Date(Date.now());
            this.parameters.from = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`
            this.parameters.to = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate() + 1}`
            this.parameters.customerPhoneNumber = null
            this.parameters.transactionCode = null
            this.parameters.orderId = null
            this.parameters.storeOrderNumber = null
            this.parameters.storeId = null
            this.parameters.paymentMethod = null
            this.parameters.isReturned = null
            this.parameters.hasTax = null
            this.parameters.type = null
        },
        allOrders() {
            this.loading = true
            adminService.allOrders(this.parameters).then(({ data }) => {
                this.parameters.totalCount = data.totalCount
                this.history = data.items
                this.loadingPage = false
                this.loading = false
            })
        },
        getListStores() {
            adminService.getListStores(this.parametersStores).then(({ data }) => {
                if (data.items.length) {
                    data.items.forEach(obj => {
                        if (obj.name_En) {
                            this.listStores.push(obj)
                        }
                    });
                }
                this.allOrders()
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        const today = new Date();
        const tomorrow = new Date();
        tomorrow.setDate(today.getDate() + 1);
        this.parameters.from = this.formatDate2(today);
        this.parameters.to = this.formatDate2(tomorrow);
        this.currentDate = this.parameters.to;
        this.getListStores()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>